module.exports = __webpack_public_path__ + "static/media/G1_REFL.bdac138b.png";